export const RESPONSE_STATE = {
	SUCCESS: "Success",
	UNAUTHORIZED: "Unauthorized",
	NOT_ALLOWED: "NotAllowed",
	NOT_FOUND: "NotFound",
	MAINTENANCE_MODE: "MaintenanceModeOn"
};
